import _ from 'lodash'
import {EitjeButton} from '~/components/eitje_button'
import {useFilterContext} from '~/components/filters'
import {startResetTable} from '~/components/advanced_table/actions'
import {getDefaultSorting, hasSortingChanged} from '~/components/advanced_table/helpers'
import {useCache} from '~/components/advanced_table/hooks'

// A 'resetTable' flag is used to prevent infinity renders. Resetting both means editing the tanStack cache and our own Redux cache.

export const ResetTableButton = ({tableName, initialPinning, fields, defaultSortColumn, defaultSortDesc, ...rest}) => {
	const {clearFilters} = useFilterContext()

	// Also reset filters when resetting the table, because otherwise you may see an empty screen (due to filters) > see the reset button >
	// click > but then still see nothing at all, because data was hidden due to the filters and not the table settings.
	const onClick = () => {
		clearFilters()
		startResetTable({tableName})
	}

	const cache = useCache({tableName})
	const watchedValues = _.pick(cache, ['visible', 'grouped', 'unpinned'])
	const noSetValues = _.values(watchedValues).every(value => _.isEmpty(value))

	const noPinningChange = _.isEqual(cache.pinned, initialPinning)
	const defaultSorting = getDefaultSorting({allTableColumns: fields, groupedColumn: cache.grouped, defaultSortColumn, defaultSortDesc})
	const noSortingChange = !hasSortingChanged({cachedSorting: cache.sorting, defaultSorting})

	// Only show the button if there are settings to reset.
	if (noSetValues && noPinningChange && noSortingChange) return null
	return <EitjeButton {...rest} t="common.reset_table" iconLeft="arrow-circle-right" onClick={onClick} />
}
